var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMarginPostpone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.625,
    cy: 21,
    r: 21,
    fill: "#FF3B30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4679 11.0771L11.7047 13.8404H14.4679V11.0771Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6229 15.21L30.7943 14.3813L29.3847 15.7909C29.209 15.7853 29.0315 15.8487 28.8977 15.9826L28.1563 16.724L29.2803 17.8479L30.0217 17.1065C30.1462 16.9821 30.2147 16.8166 30.2147 16.6406C30.2147 16.6334 30.2139 16.6263 30.2137 16.6192L31.6229 15.21Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4246 24.4536L27.3247 17.5535L28.4485 18.6774L21.5484 25.5774L20.4246 24.4536Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6796 25.3647L18.9756 27.0292L20.64 26.3251L19.6796 25.3647Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8229 28.7888L16.8258 27.7919L15.9362 28.6814H13.4944V27.5095H15.4508L16.8258 26.1346L17.7082 27.017L18.8093 24.4138L20.5464 22.6768H14.188V21.5049H21.7182L23.036 20.1872H14.188V19.0153H24.2079L26.7778 16.4454V11H15.6398V15.0126H11.6271V31H26.7778V22.0079L21.5906 27.1951L17.8229 28.7888ZM15.9408 16.5257H22.4642V17.6975H15.9408V16.5257Z",
    fill: "#FF3B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.625 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarginPostpone);
export default __webpack_public_path__ + "static/media/ic_margin_postpone.3e71aea169b00aba994b0224687c1215.svg";
export { ForwardRef as ReactComponent };